<template>
  <layout :drawerShow="false" :drawerWidth="350">
    <template slot="nav">
      <v-tabs>
        <v-tab :to="{ name: 'AdminUsers' }">Admin</v-tab>
      </v-tabs>
    </template>
    <!--<template slot="nav-tools"></template>
    <template slot="drawer"></template>-->
    <template slot="content">
      <v-container>
        <v-row dense>
          <v-col v-for="api in apis" :key="api.route" class="mb-3" cols="12" lg="6" sm="12">
            <v-card>
              <v-card-title>
                <v-chip :color="api.method === 'GET' ? 'green' : 'orange'" small dark class="mr-2">
                  {{ api.method }}
                </v-chip>
                {{ api.title }}
              </v-card-title>
              <v-card-subtitle class="mt-1">{{ api.route }}</v-card-subtitle>
              <v-card-text>
                <v-row align="center">
                  <v-col v-for="param in api.params" :key="param.name" cols="12" :sm="10/api.params.length">
                    <v-text-field
                        v-if="param.type === 'number'"
                        v-model="api.values[param.name]"
                        @keydown.enter="execute(api)"
                        :label="param.name"
                        outlined dense hide-details
                    />
                    <v-checkbox
                        v-else-if="param.type === 'boolean'"
                        v-model="api.values[param.name]"
                        :label="param.name"
                        hide-details class="mt-0"
                    />
                  </v-col>
                  <v-col cols="1">
                    <v-btn color="primary" dense small @click="execute(api)" :loading="loading">
                      <v-icon left>mdi-send</v-icon>
                      Go
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider v-if="api.body != null" class="mt-2" />
                <v-expansion-panels flat class="mt-2"   v-if="api.body != null">
                  <v-expansion-panel >
                    <v-expansion-panel-header >Ajouter body</v-expansion-panel-header>
                    <v-expansion-panel-content >
                      <v-textarea v-model="api.body">

                      </v-textarea>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-divider/>
        <v-row dense>
          <v-col cols="12" class="mt-2">
            <v-card>
              <v-card-subtitle class="mt-1">Logs</v-card-subtitle>
              <v-card-text>
                <span>{{ response.status ?? '-' }}</span>
                <br/>

                <pre>
                  {{ response.body ?? '' }}
                </pre>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </layout>
</template>
<script>

import Layout from "@/views/Layout.vue";
import {get, post} from "@/utils/api";

export default {
  name: "AdminUtils",
  components: {
    Layout
  },
  data() {
    return {
      loading: false,
      response: {
        status: null,
        body: null
      },
      apis: [
        {
          method: 'GET',
          title: 'Renvoyer facture',
          route: '/api/tmp/mail/resend/invoice/:bookingId',
          params: [
            {name: 'bookingId', type: 'number', kind: 'path'}
          ], values: {}
        },
        {
          method: 'GET',
          title: 'Renvoyer voucher dossier',
          route: '/api/tmp/mail/resend/voucher/:bookingId',
          params: [
            {name: 'bookingId', type: 'number', kind: 'path'}
          ], values: {}
        },
        {
          method: 'GET',
          title: 'Regenérer voucher ',
          route: '/api/tmp/mail/regen/voucher/:prestationId',
          params: [
            {name: 'prestationId', type: 'number', kind: 'path'},
            {name: 'force', type: 'boolean', kind: 'query'}
          ], values: {
            force: true
          }
        },
        {
          method: 'POST',
          title: 'Regenérer tous les vouchers',
          route: '/api/tmp/mail/regen/voucher/all',
          body: '',
          params: [
            {name: 'force', type: 'boolean', kind: 'query'}
          ], values: {}
        },
        {
          method: 'GET',
          title: 'Envoi email fournisseur: booking booked ',
          route: '/api/tmp/mail/sendBookPrestation',
          params: [
            {name: 'prestationGroupId', type: 'number', kind: 'query'}
          ], values: {}
        },
      ]
    }
  },
  methods: {
    buildUrl(api) {
      const url = api.params
      .filter(p => p.kind === 'path')
      .reduce((acc, param) => acc.replace(`:${param.name}`, api.values[param.name]), api.route);

      const queryParams = api.params
      .filter(p => p.kind !== 'path')
      .reduce((acc, param) => {
        acc[param.name] = api.values[param.name];
        return acc;
      }, {});

      const queryString = new URLSearchParams(queryParams).toString();
      return queryString ? `${url}?${queryString}` : url;
    },
    async call(api, url) {
      const fn = api.method === 'GET' ? () => get(url) : () => post(url, JSON.parse(api.body))
      return fn().res((response) => {
        return response
      });
    },
    async print(response) {
      this.response.status = response.status
      const contentType = response.headers.get("content-type") || ""

      if (contentType.includes("application/json")) {
        this.response.body = await response.json()
      } else {
        this.response.body = await response.text()
      }
    },
    async execute(api) {
      try {
        this.loading = true;
        const url = this.buildUrl(api)
        const response = await this.call(api, url)
        await this.print(response)
      } catch (err) {
        if (err.response) {
          this.response.status = err.status
          this.response.body = err.response.message
        } else {
          this.response.status = err?.status ?? '???'
          this.response.body = err?.message ?? "Erreur inconnue"
        }
      } finally {
        this.loading = false
      }

    },

  }
}
</script>


<style scoped>

</style>